<template>
  <div>
    <div class="sidebaradmin bgazulgradiente p-4 blanco fpG2"  v-if="userProfile.user_id ===  'rcThpvogSRce5y5FkTWAmNjnjYv1'">
      <ul>
        <!-- <li class="mb-3">
        <router-link class="blanco px-3 py-2" to="/administrador/dashboard/">INICIO</router-link>
        </li> -->
        <li
          class="mb-3"
          v-if="userProfile != null && userProfile.user_level > 5"
        >
          <router-link class="blanco px-3 py-2" to="/administrador/dashboard/"
            >CONFIGURACIÓN</router-link
          >
        </li>
        <li class="mb-3">
          <a class="blanco px-3 py-2">ADMINISTRADOR</a>
          <ul class="my-3">
            <li
              class="mb-3"
              v-if="userProfile != null && userProfile.user_level > 5"
            >
              <router-link
                class="blanco px-3 py-3"
                to="/administrador/planteles/"
                >PLANTELES</router-link
              >
            </li>
            <li
              class="mb-3"
              v-if="userProfile != null && userProfile.user_level > 5"
            >
              <router-link
                class="blanco px-3 py-3"
                to="/administrador/orientadores/"
                >ORIENTADORES</router-link>
            </li>
            <li
              class="mb-3"
              v-if="userProfile !== null && userProfile.user_level > 5"
            >
              <router-link class="blanco px-3 py-3" to="/administrador/grupos/"
                >GRUPOS</router-link
              >
            </li>
            <li class="mb-3">
              <router-link
                class="blanco px-3 py-3"
                to="/administrador/estudiantes/"
                >ESTUDIANTES</router-link
              >
            </li>
            <li
              class="mb-3"
              v-if="userProfile != null && userProfile.user_level > 5"
            >
              <router-link
                class="blanco px-3 py-3"
                to="/administrador/pruebas/"
                >PRUEBAS</router-link
              >
            </li>
          </ul>
        </li>
        <li class="mb-3">
          <a class="blanco px-3 py-2">RESULTADOS</a>
          <ul class="my-3">
            <li class="mb-3">
              <router-link
                class="blanco px-3 py-3"
                to="/administrador/resultados/interpretacion/"
                >INTERPRETACIÓN</router-link
              >
            </li>
            <li class="mb-3">
              <router-link
                class="blanco px-3 py-3"
                to="/administrador/resultados/individuales/"
                >INDIVIDUALES</router-link
              >
            </li>
          </ul>
        </li>
        <li class="mb-3">
          <a class="blanco px-3 py-2">ESTADÍSTICAS</a>

          <ul class="my-3">
            <li class="mb-3">
              <router-link
                class="blanco px-3 py-3"
                to="/administrador/estadisticas/por-nivel/"
                >POR NIVEL</router-link
              >
            </li>
            <li class="mb-3">
              <router-link
                class="blanco px-3 py-3"
                to="/administrador/estadisticas/inter-niveles/"
                >INTER NIVELES</router-link
              >
            </li>
          </ul>
        </li>
        <li class="mb-3">
          <a class="blanco px-3 py-2 pointer" @click="logout">SALIR</a>
        </li>
        <li>
          <div class="blanco ">
            <div class="fpC">
              {{ this.$store.state.version }}
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="sidebaradmin bgazulgradiente p-4 blanco fpG2"  v-else>
      <ul>
        <!-- <li class="mb-3">
        <router-link class="blanco px-3 py-2" to="/administrador/dashboard/">INICIO</router-link>
        </li> -->
        <li
          class="mb-3"
          v-if="userProfile != null && userProfile.user_level > 5"
        >
          <router-link class="blanco px-3 py-2" to="/administrador/dashboard/"
            >CONFIGURACIÓN</router-link
          >
        </li>
        <li class="mb-3">
          <a class="blanco px-3 py-2">ADMINISTRADOR</a>
          <ul class="my-3">
            <li
              class="mb-3"
              v-if="userProfile != null && userProfile.user_level == 20"
            >
              <router-link
                class="blanco px-3 py-3"
                to="/administrador/institutos/"
                >INSTITUTOS / ESCUELAS</router-link
              >
            </li>
            <li
              class="mb-3"
              v-if="userProfile != null && userProfile.institucion != undefined && userProfile.insitucion != ''"
            >
              <router-link
                class="blanco px-3 py-3"
                to="/administrador/planteles/"
                >PLANTELES</router-link
              >
            </li>
            <li
              class="mb-3"
              v-if="userProfile != null && userProfile.institucion != undefined && userProfile.insitucion != ''"
            >
              <router-link
                class="blanco px-3 py-3"
                to="/administrador/orientadores/"
                >ORIENTADORES</router-link>
            </li>
            <li
              class="mb-3"
              v-if="userProfile != null && userProfile.institucion != undefined && userProfile.insitucion != ''"
            >
              <router-link class="blanco px-3 py-3" to="/administrador/grupos/"
                >GRUPOS</router-link
              >
            </li>
            <li class="mb-3" v-if="userProfile != null && userProfile.institucion != undefined && userProfile.insitucion != ''">
              <router-link
                class="blanco px-3 py-3"
                to="/administrador/estudiantes/"
                >ESTUDIANTES</router-link
              >
            </li>
            <li
              class="mb-3"
              v-if="userProfile != null && userProfile.institucion != undefined && userProfile.insitucion != ''"
            >
              <router-link
                class="blanco px-3 py-3"
                to="/administrador/pruebas/"
                >PRUEBAS</router-link
              >
            </li>
          </ul>
        </li>
        <li class="mb-3" v-if="userProfile != null && userProfile.institucion != undefined && userProfile.insitucion != ''">
          <a class="blanco px-3 py-2">RESULTADOS</a>
          <ul class="my-3">
            <li class="mb-3">
              <router-link
                class="blanco px-3 py-3"
                to="/administrador/resultados/interpretacion/"
                >INTERPRETACIÓN</router-link
              >
            </li>
            <li class="mb-3">
              <router-link
                class="blanco px-3 py-3"
                to="/administrador/resultados/individuales/"
                >INDIVIDUALES</router-link
              >
            </li>
          </ul>
        </li>
        <li class="mb-3" v-if="userProfile != null && userProfile.institucion != undefined && userProfile.insitucion != ''">
          <a class="blanco px-3 py-2">ESTADÍSTICAS</a>

          <ul class="my-3">
            <li class="mb-3">
              <router-link
                class="blanco px-3 py-3"
                to="/administrador/estadisticas/por-nivel/"
                >POR NIVEL</router-link
              >
            </li>
            <li class="mb-3">
              <router-link
                class="blanco px-3 py-3"
                to="/administrador/estadisticas/inter-niveles/"
                >INTER NIVELES</router-link
              >
            </li>
          </ul>
        </li>
        <li class="mb-3">
          <a class="blanco px-3 py-2 pointer" @click="logout">SALIR</a>
        </li>
        <li>
          <div class="blanco ">
            <div class="fpC">
              {{ this.$store.state.version }}
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>


<script>
import { mapState } from "vuex";
import Footer from "@/components/Footer";
import Glyphicons from "@/views/Glyphicons";
import AOS from "aos";
import swal from "sweetalert2";

import * as fb from "../../firebase";
import * as moment from "moment";
import { misionesCollection, usersCollection } from "@/firebase";
import Vue from "vue";

import { ServerTable, ClientTable, Event } from "vue-tables-2";
Vue.use(ClientTable);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

export default {
  components: {},
  data() {
    return {
      initiated: false
    };
  },
  computed: {
    ...mapState(["userProfile", "institucionID"]),
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      console.log("cambio de ruta");

      this.initiated = false;

      this.init();
    },
    userProfile(value) {
      //if (value) alert(this.userProfile.nombre)
      if (value) this.init();
    },
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
    //console.log({ userProfile: this.userProfile.user_level });
    this.init();
  },
  methods: {
    init() {
      this.initiated = true;
    },
    logout() {
      this.$store.dispatch("logoutAdmin");
    },
  },
};
</script>

<style scoped>
</style>
